import { Component, Input, OnInit } from '@angular/core';

import { GlobalState } from '../../../global.state';
import { AuthenticationService } from '../../../auth/authentication.service';

import 'style-loader!./ubiPageTop.scss';

declare var $: any;

@Component({
  selector: 'ubi-page-top',
  templateUrl: './ubiPageTop.html',
})
export class UbiPageTop implements OnInit {

  @Input() options: any;
  @Input() appTitle: string;
  @Input() user: any;

  public isScrolled = false;
  public isMenuCollapsed = false;
  public urlLogout = '';

  constructor(private auth: AuthenticationService, private _state: GlobalState) {
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  ngOnInit() {
    const defaultOptions = {
      photo: true,
      profile: true,
      logout: true,
      search: false,
      msgcenter: {
        notifications: false,
        messages: false
      }
    };

    this.options = Object.assign(defaultOptions, this.options);

  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }

  public logout() {
    $('.content-top .al-title').text('');
    this.auth.logout();
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiPageTop/ubiPageTop.component.ts